var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBannerManagement(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6616 2H3.33185C2.59575 2 1.99902 2.59673 1.99902 3.33282V12.6626C1.99902 13.3987 2.59575 13.9954 3.33185 13.9954H12.6616C13.3977 13.9954 13.9944 13.3987 13.9944 12.6626V3.33282C13.9944 2.59673 13.3977 2 12.6616 2Z",
    stroke: "#D1D5DC",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99786 7.32971C6.73396 7.32971 7.33069 6.73299 7.33069 5.99689C7.33069 5.26079 6.73396 4.66406 5.99786 4.66406C5.26177 4.66406 4.66504 5.26079 4.66504 5.99689C4.66504 6.73299 5.26177 7.32971 5.99786 7.32971Z",
    stroke: "#D1D5DC",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9942 9.99756L11.9377 7.94101C11.6877 7.69115 11.3488 7.55078 10.9954 7.55078C10.642 7.55078 10.303 7.69115 10.0531 7.94101L3.99805 13.996",
    stroke: "#D1D5DC",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerManagement);
export default __webpack_public_path__ + "static/media/banner_management.717093c7bc21dfd6f328a8e2bc32e7c1.svg";
export { ForwardRef as ReactComponent };